import classNames from 'classnames';
import { Icon, IconID } from '@hub/common/Icon/Icon';
import type { IconColor } from '@hub/common/Icon/Icon';
import type { ReactNode } from 'react';

export interface LinkProps {
  icon?: IconID;
  bigIcon?: boolean;
  iconPrimary?: boolean;
  iconColor?: IconColor;
  text?: string;
  href?: string;
  flex?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  external?: boolean;
  download?: boolean;
  primary?: boolean;
  className?: string;
  children?: ReactNode;
  dataTestId?: string;
}

export const Link = ({
  icon,
  bigIcon = false,
  iconPrimary = true,
  iconColor,
  text,
  href,
  onClick,
  external,
  download,
  primary,
  flex = true,
  className,
  children,
  dataTestId = 'link-a',
}: LinkProps) => (
  // eslint can't figure out that we correctly set 'noreferrer' on external links
  // since it set dynamically
  // eslint-disable-next-line react/jsx-no-target-blank
  <a
    data-testid={dataTestId}
    onClick={onClick}
    href={href}
    target={external && '_blank'}
    rel={external && 'noreferrer'}
    download={download}
    className={classNames(
      'medium cursor-pointer group',
      primary && 'text-igus-primary hover:text-igus-primary-600 no-shadow-link',
      flex && 'flex flex-row',
      className
    )}
  >
    {icon && (
      <span
        className={classNames(
          'mr-4',
          {/* this is a special case from the old page: different style for the right arrow when hovered */},
          !iconPrimary && icon === IconID.ARROW_RIGHT ? 'text-gray-200 group-hover:text-gray-500' : ''
        )}
      >
        <Icon id={icon} size={bigIcon ? 6 : 4} primary={iconPrimary} color={iconColor} />
      </span>
    )}
    {text || children}
  </a>
);
